var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "ntak-dashboard-container",
        class: { "hidden-form": !_vm.showForm }
      },
      [
        _c("h1", { staticClass: "ntak-dashboard-title" }, [
          _vm._v("\n      NTAK Dashboard\n    ")
        ]),
        _c(
          "div",
          [
            _c(
              "a-form",
              { attrs: { form: _vm.form, layout: "vertical" } },
              [
                _c(
                  "a-form-item",
                  { attrs: { label: "Iroda" } },
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "id",
                              {
                                rules: [
                                  {
                                    required: _vm.isAdmin || _vm.isViewer,
                                    whitespace: true,
                                    message: "Kérjük töltse ki!",
                                    type: "integer"
                                  }
                                ],
                                validateTrigger: ["blur", "keyup"]
                              }
                            ],
                            expression:
                              "[\n                          'id',\n                          {\n                              rules: [\n                                  {\n                                  required: isAdmin || isViewer,\n                                  whitespace: true,\n                                  message: 'Kérjük töltse ki!',\n                                  type: 'integer'\n                                },\n                              ],\n                              validateTrigger: ['blur','keyup']\n                          }\n                      ]"
                          }
                        ],
                        style: { width: "100%" },
                        attrs: {
                          placeholder: "Kezdjen gépelni",
                          showSearch: "",
                          showArrow: false,
                          defaultActiveFirstOption: false,
                          filterOption: false,
                          notFoundContent: _vm.officeOptionsLoading
                            ? undefined
                            : null
                        },
                        on: {
                          change: function(value) {
                            return (_vm.officeId = value)
                          },
                          search: _vm.officeAutoComplete,
                          dropdownVisibleChange: _vm.officeAutoComplete
                        }
                      },
                      [
                        _vm.officeOptionsLoading
                          ? _c("a-spin", {
                              attrs: { slot: "notFoundContent", size: "small" },
                              slot: "notFoundContent"
                            })
                          : _vm._e(),
                        _vm._l(_vm.officeOptions, function(option) {
                          return _c(
                            "a-select-option",
                            { key: option.id, attrs: { value: option.id } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(option.name) +
                                  "\n            "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]
    ),
    _c("div", [
      _c("iframe", {
        class: { "hidden-form": !_vm.showForm },
        attrs: { src: "/api/v1/companies/1/compass/" + _vm.officeId + "/" }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }